/*
  Clive: keep .clive-cart-has-items on the header cart count in step with the cart.

  sections/header.liquid sets the class server-side for the page-load count. After an
  add or remove, Stiletto's header updateCartCount() rewrites each count's innerHTML
  and nothing else, so watch the text and toggle the class. The colour itself lives in
  assets/custom.css.
*/
(function () {
  function sync(el) {
    var n = parseInt(el.textContent, 10);
    el.classList.toggle('clive-cart-has-items', n > 0);
  }

  function init() {
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      sync(el);
      new MutationObserver(function () { sync(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
